class BikiniConfiguratorSwiper extends HTMLElement {
  constructor() {
    super();
    this.utils = new Utils();
    this.isMobile = this.utils.isMobile();
  }

  connectedCallback() {
    this.enableSwiper();
    this.onBikiniUpdate = subscribe(PUB_SUB_EVENTS.onBikiniConfiguratorUpdate, (event) => {
      const type = this.dataset.type;
      if (('swiper-' + type) === event?.eventType)
        this.enableSwiper(event.startIndex || 0);
    });
  }

  disconnectedCallback() {
    this.onBikiniUpdate && this.onBikiniUpdate()
  }

  enableSwiper(index = 0) {
    if (this.swiper) 
      this.swiper.destroy();
    
    const configuration = {
      slidesPerView: this.isMobile ? 1.9 : 1.7,
      centeredSlides: true,
      initialSlide: index,
      navigation: {
        nextEl: ".swiper-pagination-next",
        prevEl: ".swiper-pagination-prev",
        clickable: true,
      },
      on: {
        slideChangeTransitionEnd: this.onSlideChangeTransitionEnd.bind(this),
      }
    };
    
    this.swiper = new Swiper(this.querySelector(".swiper-container"), configuration);
  }

  onSlideChangeTransitionEnd(event) {
    const index = event.activeIndex;
    const slide = event.slides[index] || null;
    if (!slide) return;

    publish(PUB_SUB_EVENTS.onBikiniConfiguratorChange, {
      eventType: "swipe",
      data: {
        handle: slide.dataset.handle,
        type: this.dataset.type
      }
    });
  }


  static createSlide(product) {
    let image = undefined;
    try {
      const featuredImage =  product.images[0].url;
      const configuratorImage = product.configuratorImage?.image?.url;

      image = configuratorImage || featuredImage;
    } catch (error) {
      console.log(error)
    }

    const listItem = document.createElement('a');
    listItem.className = 'swiper-slide [&_img]:tw-aspect-[426/268] [&_img]:tw-w-full [&_img]:tw-h-full [&_img]:tw-object-cover';
    listItem.setAttribute('data-handle', product.handle);
    listItem.setAttribute('data-model', product.model);
    listItem.setAttribute('href', '/products/' + product.handle)

    const imgElement = new Image();
    imgElement.src = `${image}?width=852`;
    imgElement.srcset = `
      ${image}?width==426 426w,
      ${image}?width==852 852w
    `;
    imgElement.width = "426";
    imgElement.className = 'tw-w-full';
    imgElement.loading = 'lazy';

    listItem.appendChild(imgElement);

    return listItem
  }
}
customElements.define("bikini-configurator-swiper", BikiniConfiguratorSwiper);

class BikiniColors extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onBikiniUpdate = subscribe(PUB_SUB_EVENTS.onBikiniConfiguratorUpdate, (event) => {
        if (event !== 'variant')
          this.handleColorSelection();
    });
  }

  disconnectedCallback() {
    this.onBikiniUpdate && this.onBikiniUpdate()
  }

  handleColorSelection() {
    const colorSelectors = this.querySelectorAll(".color-selector");
    colorSelectors.forEach((colorSelector) => {
      colorSelector.addEventListener("click", this.onColorSelect.bind(this));
    });
  }

  onColorSelect(event) {
    this.dataset.currentColor = event.target.dataset.color;
    this.dataset.currentColorCode = event.target.dataset.colorCode;

    publish(PUB_SUB_EVENTS.onBikiniConfiguratorChange, {
      eventType: "color",
      data: {
        color: event.target.dataset.color,
        code: event.target.dataset.colorCode
      }
    });
  }

  static create(colors) {
    const uniqueColors = [];

    let colorsHTML = colors.map(color => {
      if (uniqueColors.includes(color.color_code)) 
        return;
      uniqueColors.push(color.color_code);

      const checked = color.checked ? "underline-effect after:tw-scale-x-100 after:tw-bg-black" : "";
      return `
        <div 
          data-color="${color.color}"
          data-color-code="${color.color_code}"
          class="tw-h-30 tw-w-50 tw-rounded-4 color-selector tw-cursor-pointer ${checked}" 
          style="background-color: ${color.color_code}">
        </div>`;
    });
    return colorsHTML.join("");
  }
}
customElements.define("bikini-colors", BikiniColors);

class BikiniConfigurator extends HTMLElement {
  constructor() {
    super();
    this.utils = new Utils();
    /** Object Definition [model String]*/
    this.cache = {};
    this.cart = document.querySelector('cart-items') || document.querySelector('cart-drawer');
  }

  get top() {
    return this.wrapper("top").querySelector('[data-selected-variant]').dataset.handle;
  }

  get topModel() {
    return this.wrapper("top").querySelector('[data-selected-variant]').dataset.model;
  }

  get bottom() {
    return this.wrapper("bottom").querySelector('[data-selected-variant]').dataset.handle;
  }

  get bottomModel() {
    return this.wrapper("bottom").querySelector('[data-selected-variant]').dataset.model;
  }

  get form() {
    return this.querySelector("form");
  }

  get submit() {
    return this.querySelector("button[type='submit']");
  }

  get currentColor() {
    return {
      color: this.querySelector('bikini-colors').dataset.currentColor,
      code: this.querySelector('bikini-colors').dataset.currentColorCode
    }
  }

  wrapper(type) {
    return this.querySelector(`[data-wrapper="${type}"`);
  }

  async connectedCallback() {
    const [top, bottom] = await this.getCurrentModelBikiniColors();
    this.renderColors(top, bottom);
    publish(PUB_SUB_EVENTS.onBikiniConfiguratorUpdate, 'color');

    this.setVariantsListener();
    this.refreshButton();


    subscribe(PUB_SUB_EVENTS.onBikiniConfiguratorChange, (event) => {
      this.eventHandler(event);
    });

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.onBuy();
    });
  }

  setVariantsListener() {
    const form = this.form;

    form.addEventListener("change", (event) => {
      if (event.target.tagName === "INPUT") {
        publish(PUB_SUB_EVENTS.onBikiniConfiguratorChange, {
          eventType: "variant",
          data: {
            handle: event.target.dataset.handle,
            option: event.target.value,
            type: event.target.closest("fieldset").dataset.type
          }
        });
      };
    });
  }


  async eventHandler(event) {
    switch (event.eventType) {
      case "variant":
        await this.onVariantChange(event);
        break;
      case "swipe":
        await this.onSwiperChange(event);
        break;
      case "color":
        await this.onColorChange(event);
        break;     
    }
    publish(PUB_SUB_EVENTS.onBikiniConfiguratorUpdate, event.eventType);
    this.refreshButton();
  }


  async onVariantChange(event) {
    const data = event.data;
    const type = data.type

    const [handle, option] = [data.handle, data.option];

    const html = await this.getBikiniHTML(handle, option);
    for (let section of this.getSectionToRender(event.eventType)) 
      ProductUtils.updateSource(this.wrapper(type), html, section, true);   
  }

  async onSwiperChange(event) {
    const data = event.data;

    const type = data.type;
    const handle = data.handle;

    const html = await this.getBikiniHTML(handle);

    for (let [section, updateAttributes] of this.getSectionToRender(event.eventType))
      ProductUtils.updateSource(this.wrapper(type), html, section, updateAttributes);

    const [top, bottom] = await this.getCurrentModelBikiniColors();
    this.renderColors(top, bottom);
  }

  async onColorChange(event) {
    const [topSiblings, bottomSiblings] = await this.getBikiniColors();
    
    for (let item of [{type: "top", siblings: topSiblings}, {type: "bottom", siblings: bottomSiblings}]) {
      const type = item.type;
      let siblings = item.siblings;

      const swiper = this.querySelector(`bikini-configurator-swiper[data-type='${type}']`);
      const currentModel = this.wrapper(type).querySelector('[data-selected-variant]').dataset.model;

      const newSlides = [];
      let startIndex = 0;

      Array.from(swiper.querySelectorAll('.swiper-slide')).forEach((slide, index) => {
        const slideModel = slide.dataset.model;
        const currentSibling = siblings.find(item => item.model === slideModel);
        if (!currentSibling) {
          slide.remove();
          return;
        }

        siblings = siblings.filter(item => item.model !== slideModel);
        startIndex = slide.dataset.model === currentModel ? index : 0;
        const newSlide = BikiniConfiguratorSwiper.createSlide(currentSibling);
        slide.replaceWith(newSlide);
      });

      for (let sibling of siblings) {
          newSlides.push(BikiniConfiguratorSwiper.createSlide(sibling));
      }
      swiper.querySelector('.swiper-wrapper').append(...newSlides);
      publish(PUB_SUB_EVENTS.onBikiniConfiguratorUpdate, {eventType: 'swiper-' + type, startIndex: startIndex});


      const handle = swiper.querySelector('.swiper-slide.swiper-slide-active').dataset.handle;

      const html = await this.getBikiniHTML(handle);
      for (let [section, updateAttributes] of this.getSectionToRender(event.eventType))
        ProductUtils.updateSource(this.wrapper(type), html, section, updateAttributes);

    }

    const [top, bottom] = await this.getCurrentModelBikiniColors();
    this.renderColors(top, bottom);
  }

  async onBuy() {
    this.querySelector('.loading__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = { items: [], sections_url: window.location.pathname, sections: this.cart.getSectionsToRender().map((section) => section.id) };

    const variants = Array.from(this.querySelectorAll("[data-selected-variant]"))
        .map(variantHtml => !!variantHtml.innerHTML ? JSON.parse(variantHtml.innerHTML) : null)
        .filter(variant => variant !== null);

    variants.forEach(variant => {
      formData.items.push({
        id: variant.id,
        quantity: 1,
        properties: {}
      })
    })

    const propertyInputs =
        this.querySelectorAll('input[name^="properties"]');

      propertyInputs?.forEach(input => {
        formData.items.forEach(item => {
            if (!input?.value) return
            const match = input.name.match(/\[(.*?)\]/);
            const extracted = match ? match[1] : null;
            item.properties[extracted] = input.value
        })
      });

      config.body = JSON.stringify(formData);
      config.headers = {
        'Content-Type': 'application/json',
        ...config.headers
      };
      
      const fetchResponse = await fetch(`${routes.cart_add_url}`, config);
      const response = await fetchResponse.json()
      
      this.querySelector('.loading__spinner').classList.add('hidden');
      if (response.status) {
        const message = response.message;
        this.querySelector('[data-error-message]').innerHTML = message;
        return;
      }

      this.cart.onCartUpdate ? this.cart.onCartUpdate() : this.cart.renderContents(response);
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
  }

  refreshButton() {
    const button = this.submit;
    const color = this.currentColor.code;

    const variantsHtml = this.querySelectorAll("[data-selected-variant]");

    let [add, remove] = ['not-active', 'active'];
    let buttonText = window.variantStrings.selectOptions;
    
    const variants = Array.from(variantsHtml)
        .map(variantHtml => !!variantHtml.innerHTML ? JSON.parse(variantHtml.innerHTML) : null)
        .filter(variant => variant !== null);

    this.changeBtnColor(color);
    this.querySelector('[data-error-message]').innerHTML = "";

    if (variants.length === 0) return; 
    else if (variants.length > 0) {
        [add, remove] = ['active', 'not-active'];
        buttonText = window.variantStrings.addToCart;
    }

    button.classList.add(add);
    button.classList.remove(remove);

    const buttonSpan = button.querySelector("span");
    const currency = buttonSpan.dataset.currency;  
    const price = variants.reduce((acc, variant) => acc + variant.price, 0);

    buttonSpan.textContent = `${this.utils.formatMoney(price, `${currency}`)} - ${buttonText}`;
  }

  changeBtnColor(hex) {
    const btnColor = hex || '#032e5b'
    const btn = this.submit;
    
    btn.style.color = isColorDark(btnColor) ? 'white' : '#032e5b'
    btn.style.backgroundColor = btnColor

    function hexToRgb(hex) {
        hex = hex.replace(/^#/, '');

        let bigint = parseInt(hex, 16);
        let r = (bigint >> 16) & 255;
        let g = (bigint >> 8) & 255;
        let b = bigint & 255;

        return [r, g, b];
    }

    function getLuminance(r, g, b) {
        let a = [r, g, b].map(function(v) {
            v /= 255;
            return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        });

        return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    }

    function isColorDark(hex) {
        let [r, g, b] = hexToRgb(hex);
        let luminance = getLuminance(r, g, b);

        return luminance < 0.5;
    }

  }

  async getBikiniColors() {
    const currentColor = this.currentColor.color;

    const [topResponse, bottomResponse] = await Promise.all([
      fetch(window.storefront.api_url, this.buildQuery([`Category_TOP`, `CC-${currentColor}`])),
      fetch(window.storefront.api_url, this.buildQuery([`Category_BOTTOM`, `CC-${currentColor}`])),
    ]);

    const top = await topResponse.json();
    const bottom = await bottomResponse.json();

    const [topSibling, bottomSibling] = [this.getSiblings(top), this.getSiblings(bottom)];

    return [topSibling, bottomSibling];
  }

  async getCurrentModelBikiniColors() {
    return await Promise.all([
      this.fetchCurrentModel([`Category_TOP`, this.topModel]),
      this.fetchCurrentModel([`Category_BOTTOM`, this.bottomModel]),
    ]);
  }

  async fetchCurrentModel([category, model]) {
    if (this.cache[model]) 
      return this.cache[model];

    const response = await fetch(window.storefront.api_url, this.buildQuery([category, `Model_${model}`]));
    const responseJson =  await response.json();

    const result = this.getSiblings(responseJson);
    this.cache[model] = result;

    return result;
  }

  async getBikiniHTML(handle, option = 0) {
    const url = option
      ? `${this.utils.getRequestUrlBase()}/products/${handle}?option_values=${option}&view=bikini-configurator-variant`
      : `${this.utils.getRequestUrlBase()}/products/${handle}?view=bikini-configurator-variant`;

    if (this.cache[url]) 
      return this.cache[url];

    const response = await fetch(url);
    const responseText = await response.text();
    
    const html = new DOMParser().parseFromString(responseText, "text/html");
    this.cache[url] = html;

    return html;
  }

  renderColors(top, bottom) {
    const intersection = this.getIntersectionByColor(top, bottom);

    this.querySelector("bikini-colors").innerHTML =
      BikiniColors.create(intersection);
  }

  getSectionToRender(eventType) {
    const sections = {
        variant: [
            ["[data-selected-option]", true],
            ["[data-selected-variant]", true]
        ],
        swipe: [
            ["[data-product-title]", false],
            ["[data-product-model]", false],
            ["[data-option-value]", false],
            ["fieldset", false],
            ["[data-selected-variant]", true]
        ],
        color: [
          ["[data-product-title]", false],
          ["[data-product-model]", false],
          ["[data-option-value]", false],
          ["fieldset", false],
          ["[data-selected-variant]", true]
      ]
    };
    return sections[eventType] || [];
  }

  getSiblings(result) {
      const siblings = [];
      
      result.data.products.edges.forEach(edge => {
          const item = edge.node;
          const model = item.model?.value;
          const color = item.tags.find(tag => tag.includes("CC-"))?.split("-")[1];
          const type = item.tags.find(tag => tag.includes("Category_"))?.split("_")[1];

          if (!model || !color) return;

          const finalItem = {
              handle: item.handle,
              color: color,
              color_name: item.color_name?.value,
              color_code: item.color_code?.value,
              images: item.images?.edges.map(imageEdge => imageEdge.node),
              configuratorImage: item.configurator_image?.reference,
              type: type,
              model: model
          };

          siblings.push(finalItem);
      });

      return siblings;
  }

  getIntersectionByColor(tops, bottoms) {  
    let intersection = tops.filter(top => {
      return bottoms.some(bottom => {
        return (
          top.color_code &&
          bottom.color_code &&
          top.color_code === bottom.color_code
        );
      });
    });

    
    return intersection
      .map(item => ({
        ...item,
        checked: item.color_code === this.currentColor.code
      }))
      .sort((a, b) => a.color - b.color);
  }

  buildQuery(filters) {
    const queryFilter = filters
      .map(filter => `tag:'${filter}'`)
      .join(' AND ');

    return this.utils.getGraphQLBody(`
      query {
        products(query: "${queryFilter}", first: 250) {
          edges {
            node {
              handle
              tags
              images(first: 1) {
                edges {
                  node {
                    altText
                    url
                  }
                }
              }
              configurator_image: metafield(
                  namespace: "custom",
                  key: "configurator_image_"
              )   {
                  value
                  type
                    reference {
                      ... on MediaImage {
                        id
                        image {
                          url
                        }
                      }
                    }
              }
              color: metafield(namespace: "4Seasons", key: "usr_color") {
                value
              }
              color_name: metafield(namespace: "4Seasons", key: "usr_color") {
                value
              }
              color_code: metafield(namespace: "custom", key: "configurator_color") {
                value
              }
              model: metafield(namespace: "4Seasons", key: "usr_modello") {
                value
              }
            }
          }
        }
      }
    `);
}
}
customElements.define("bikini-configurator", BikiniConfigurator);
